import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useNavigationTabPanelHeaderStyles = makeStyles({
  header: {
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalS),
  },
  headerText: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
  },
});
